import type { RouteRecordRaw } from 'vue-router';

import { EnumRoutes } from '@/helpers/enums/routes.enum';

export const miscellaneousRoutes: Array<RouteRecordRaw> = [
  {
    name: EnumRoutes.misc.notifications.name,
    path: EnumRoutes.misc.notifications.path,
    component: () =>
      import('@/components/header/notifications/NotificationsPage.vue'),
    meta: EnumRoutes.misc.notifications.meta,
  },
  {
    name: EnumRoutes.misc.conversation.name,
    path: EnumRoutes.misc.conversation.path,
    component: () => import('@/views/threads/Threads.vue'),
    meta: EnumRoutes.misc.conversation.meta,
    children: [
      {
        name: EnumRoutes.misc.singleConversation.name,
        path: EnumRoutes.misc.singleConversation.path,
        meta: EnumRoutes.misc.singleConversation.meta,
        component: () => import('@/views/threads/SingleThread.vue'),
      },
    ],
  },
  {
    name: EnumRoutes.misc.notFound.name,
    path: EnumRoutes.misc.notFound.path,
    component: () => import('@/views/misc/NotFound.vue'),
    meta: EnumRoutes.misc.notFound.meta,
  },
  {
    name: EnumRoutes.misc.noLectureLinks.name,
    path: EnumRoutes.misc.noLectureLinks.path,
    component: () => import('@/views/misc/NoLectureLinks.vue'),
    meta: EnumRoutes.misc.noLectureLinks.meta,
  },
];
